import { auth, db } from "./firebase";
import { ref, get } from "firebase/database";

export function saveSessionRole(role, info) {
  try {
    sessionStorage.setItem("festumRole", role);
    sessionStorage.setItem("festumInfo", JSON.stringify(info || {}));
  } catch {}
}
export function clearSessionRole() {
  try {
    sessionStorage.removeItem("festumRole");
    sessionStorage.removeItem("festumInfo");
  } catch {}
}
export function getSessionRole() {
  return sessionStorage.getItem("festumRole");
}
export function getSessionInfo() {
  try {
    const raw = sessionStorage.getItem("festumInfo");
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function b64(s) { return btoa((s || "").toLowerCase()); }

export async function resolveRole() {
  const u = auth.currentUser;
  if (!u?.email) return null;
  const key = b64(u.email);
  const adminSnap = await get(ref(db, `adminsByEmail/${key}`));
  if (adminSnap.exists() && adminSnap.val() === true) return "admin";
  const volSnap = await get(ref(db, `volunteersByEmail/${key}`));
  if (volSnap.exists()) return "volunteer";
  return "participant";
}
